import { TKey } from "@/app/translations/TKey";

const AFTER_INSTALL_STEP_KEYS: TKey[] = [
  TKey.MESSAGES_CONTENT_GUIDE_STEP_2,
  TKey.MESSAGES_CONTENT_GUIDE_STEP_3,
  TKey.MESSAGES_CONTENT_GUIDE_STEP_4,
];

export function sendingGuideStepKeys(isInstalled: boolean | null): TKey[] {
  if (isInstalled) {
    return AFTER_INSTALL_STEP_KEYS;
  }
  return [TKey.MESSAGES_CONTENT_GUIDE_STEP_1, ...AFTER_INSTALL_STEP_KEYS];
}
